
import React from 'react';
import PropTypes from 'prop-types';

import restrictNumber from '../../../utils/restrictNumber';
import ColorInput from '../../../components/common/ColorInput';
import {
  StyledOptionColorRow,
  StyledOptionSliderSlot,
  StyledOptionStack,
  StyledSpacedOptionFields,
} from './AnnotationOptions.styled';
import Slider from '../Slider';

const MIN_PERCENTANGE = 0;
const MAX_PERCENTANGE = 10;
const POPUP_SLIDER_WIDTH = '100%';

const StrokeFields = ({ annotation, updateAnnotation, t }) => {
  const { stroke, strokeWidth } = annotation;

  const changeStrokeWidth = (newStrokeWidth) => {
    updateAnnotation({
      strokeWidth: restrictNumber(
        newStrokeWidth,
        MIN_PERCENTANGE,
        MAX_PERCENTANGE,
      ),
    });
  };

  const changeStrokeColor = (newStrokeColor) => {
    updateAnnotation({ stroke: newStrokeColor });
  };

  return (
    <StyledSpacedOptionFields className="respark_annotation-option-panel">
      <StyledOptionStack>
        <StyledOptionSliderSlot>
          <Slider
            width={POPUP_SLIDER_WIDTH}
            annotation="px"
            onChange={changeStrokeWidth}
            value={strokeWidth}
            min={MIN_PERCENTANGE}
            max={MAX_PERCENTANGE}
          />
        </StyledOptionSliderSlot>
        <StyledOptionColorRow>
          <ColorInput color={stroke} onChange={changeStrokeColor} />
        </StyledOptionColorRow>
      </StyledOptionStack>
    </StyledSpacedOptionFields>
  );
};

StrokeFields.propTypes = {
  annotation: PropTypes.instanceOf(Object).isRequired,
  updateAnnotation: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default StrokeFields;
